//ici le composant de formaulaire contacte et on va utiliser le formulaire pour envoyer un message vers mon email

import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";
import "./contact.css";

const Contact = () => {
  const [state, handleSubmit] = useForm("xoqgnolb");
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.pageYOffset > 200) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (state.succeeded) {
    return <p className="greenmessage">Message envoyé avec succès!</p>;
  }

  return (
    <div className="contact">
      <form onSubmit={handleSubmit} className="contact-form">
        <h2>Contactez-moi</h2>
        <div className="form-control">
          <label htmlFor="email">Email Address</label>
          <input id="email" type="email" name="email" />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>
        <div className="form-control">
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>
        <button type="submit" className="btn" disabled={state.submitting}>
          Envoyer
        </button>
      </form>
      {showScrollButton && (
        <button onClick={scrollToTop} className="scroll-to-top">
          ↑
        </button>
      )}
    </div>
  );
};

export default Contact;
